module.exports = __webpack_public_path__ + "img/aus.503a3a98.svg";